/**
 * Throttle function execution
 * @param {Function} callback - Function to throttle
 * @param {number} interval - Throttle interval in ms
 * @returns {Function}
 */
export function throttle(callback, interval) {
	let enableCall = true;

	return function (...args) {
		if (!enableCall) return;

		enableCall = false;
		callback.apply(this, args);
		setTimeout(() => (enableCall = true), interval);
	};
}

/**
 * Set a cookie
 * @param {string} name - Cookie name
 * @param {*} value - Cookie value
 * @param {number} [days=365] - Expiry in days (default 365)
 * @param {Object} [options={}] - Additional cookie options
 * @param {string} [options.path='/'] - Cookie path
 * @param {string} [options.domain] - Cookie domain
 * @param {boolean} [options.secure] - Secure flag
 * @param {string} [options.sameSite='Lax'] - SameSite attribute
 */
export function setCookie(name, value, days = 365, options = {}) {
	const { path = "/", domain, secure, sameSite = "Lax" } = options;

	let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		cookieString += `; expires=${date.toUTCString()}`;
	}

	cookieString += `; path=${path}`;

	if (domain) {
		cookieString += `; domain=${domain}`;
	}

	if (secure) {
		cookieString += "; secure";
	}

	if (sameSite) {
		cookieString += `; samesite=${sameSite}`;
	}

	document.cookie = cookieString;
}
